import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import Tippy from '@tippyjs/react';
import PropTypes from 'prop-types';
import { IlTippyPlacement, IlTippyTheme } from '../../shared/constants/tippyConstants.js';
import { cssClassPrefix } from '../../shared/constants/generalConstants.js';

var _excluded = ["forwardedRef", "className"];
var TippyWrapperAppendTo = {
  AppendTo: 'parent'
};
var TippyWrapper = /*#__PURE__*/function (_Component) {
  function TippyWrapper() {
    _classCallCheck(this, TippyWrapper);
    return _callSuper(this, TippyWrapper, arguments);
  }
  _inherits(TippyWrapper, _Component);
  return _createClass(TippyWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        forwardedRef = _this$props.forwardedRef;
        _this$props.className;
        var rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React__default.createElement(Tippy, _extends({
        ref: forwardedRef
      }, rest, {
        className: ["".concat(cssClassPrefix, "--tooltip-tippy__container"), this.props.className].filter(Boolean).join(' ')
      }));
    }
  }]);
}(Component);
_defineProperty(TippyWrapper, "defaultProps", {
  placement: IlTippyPlacement.Bottom,
  appendTo: 'parent',
  arrow: true,
  theme: IlTippyTheme.Light
});
_defineProperty(TippyWrapper, "propTypes", _objectSpread2(_objectSpread2({}, Tippy.propTypes), {}, {
  placement: PropTypes.oneOf(Object.values(IlTippyPlacement)),
  appendTo: PropTypes.oneOf(Object.values(TippyWrapperAppendTo)),
  arrow: PropTypes.bool,
  theme: PropTypes.oneOf(Object.values(IlTippyTheme))
}));
var IlTooltipTippy = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(TippyWrapper, _extends({
    forwardedRef: ref
  }, props));
});

export { IlTooltipTippy };
